import type { QueryClient } from '@tanstack/react-query';

/** Refresh every activity surface backed by a loan mutation. */
export function invalidateLoanActivity(queryClient: QueryClient, loanId: string) {
  queryClient.invalidateQueries({ queryKey: ['loans', loanId, 'activity'], exact: true });
  queryClient.invalidateQueries({ queryKey: ['entity-history', 'LOAN', loanId], exact: true });
  queryClient.invalidateQueries({ queryKey: ['activity', 'global'] });
}
